import script from "./u_c_113F49.vue?vue&type=script&setup=true&lang=js"
export * from "./u_c_113F49.vue?vue&type=script&setup=true&lang=js"

import "./u_c_113F49.vue?vue&type=style&index=0&id=71cbb590&lang=scss&scoped=true"

import exportComponent from "/www/auto.37games.com/@mono/buildSpace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-71cbb590"]])

export default __exports__